var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJohangly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 222,
    viewBox: "0 0 221 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_716_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.008 179.713C140.428 164.274 155.767 123.75 146.244 102.519C162.247 138.195 147.317 179.632 112.897 195.072C78.4775 210.512 37.6014 194.107 21.5981 158.431C32.135 181.921 71.588 195.153 106.008 179.713Z",
    fill: "#1A9EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.708 47.5119C132.968 14.5526 82.8671 11.2372 65.0071 28.9784C95.018 -0.833075 145.888 1.71862 178.628 34.6778C211.368 67.637 213.58 118.523 183.569 148.334C203.329 128.706 198.448 80.471 165.708 47.5119Z",
    fill: "#004980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0458 165.541C94.679 177.928 133.643 158.975 141.284 136.996C128.445 173.929 89.151 193.828 53.5187 181.441C17.886 169.055 -0.592322 129.073 12.2463 92.1401C3.79308 116.458 23.4131 153.155 59.0458 165.541Z",
    fill: "#FFD643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0458 165.541C94.679 177.928 133.643 158.975 141.284 136.996C128.445 173.929 89.151 193.828 53.5187 181.441C17.886 169.055 -0.592322 129.073 12.2463 92.1401C3.79308 116.458 23.4131 153.155 59.0458 165.541Z",
    fill: "#4DB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.336 89.897C163.627 46.1768 115.317 23.5174 88.3495 33.2074C133.665 16.9247 183.136 39.1669 198.845 82.887C214.554 126.607 190.554 175.249 145.238 191.531C175.075 180.81 195.046 133.617 179.336 89.897Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 140.428C174.146 95.9899 148.968 48.9435 121.557 40.5879C167.617 54.6282 193.975 102.034 180.429 146.472C166.883 190.91 118.563 215.552 72.5032 201.512C102.83 210.756 147.054 184.866 160.6 140.428Z",
    fill: "#0084E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.555 156.796C116.109 156.796 142.498 130.407 142.498 97.8531C142.498 65.2995 116.109 38.9097 83.555 38.9097C51.0014 38.9097 24.6116 65.2995 24.6116 97.8531C24.6116 130.407 51.0014 156.796 83.555 156.796Z",
    fill: "#002C4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_716_71",
    x: 0.16748,
    y: 0.1875,
    width: 220.539,
    height: 221.268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_716_71"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_716_71",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJohangly);
export default __webpack_public_path__ + "static/media/johangly.4d42f11fe7abe375440fea1cd845b79b.svg";
export { ForwardRef as ReactComponent };